// imports section Start
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled, useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import visa from "../../../assets/images/visa.png";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  IconButton,
  Stack,
  TextField,
  Radio,
  RadioGroup,
  ToggleButton,
  ToggleButtonGroup,
  FormLabel,
  FormControl,
  FormControlLabel,
  Card,
  CardContent,
} from "@mui/material";
import { BASEURL } from "../../../config/Config";
import {
  externalgetApi,
  externalpostApi,
} from "../../../services/external/externalApis";
import { COMMON_API_04, COMMON_API_05 } from "../../../api/ApiModel";
import { addCard, removeCard } from "../../../store/ReduxCardSlice";
import SnackbarMessage from "../../common/SnackbarMessage";
// imports section End

const CashierCard = ({ formData = {}, setFormData }) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  const cardList = useSelector((state) => state.cards.cardList);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [error, setError] = useState(null);
  const [payments, setPayments] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    fetchBanks();
  }, []);

  useEffect(() => {
    fetchBranches();
  }, [selectedBank]);
  // Hooks end

  // Handlers start
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      card: {
        ...prev.card,
        [name.split(".").pop()]: value,
      },
    }));
  };
  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      // style: "currency",
      // currency: "LKR",
    }).format(price);
  };

  // Handle bank selection and update form data
  const handleBankChange = (event) => {
    const { value } = event.target;
    console.log(value); // Log the selected bank code
    setSelectedBank(value);
    setFormData((prev) => ({
      ...prev,
      card: {
        // Make sure to update 'card' field
        ...prev.card,
        cardbank: value,
      },
    }));
    setBranches([]); // Reset branches when changing bank
  };

  // Handle branch selection and update form data
  const handleBranchChange = (event) => {
    const { value } = event.target;
    console.log(value); // Log the selected branch code
    setSelectedBranch(value);
    setFormData((prev) => ({
      ...prev,
      card: {
        // Make sure to update 'card' field
        ...prev.card,
        cardbranch: value,
      },
    }));
  };

  const handleAddPayment = () => {
    // Add card to Redux state
    if (
      formData.card.cardamount === undefined ||
      formData.card.cardamount === "" ||
      formData.card.cardbank === undefined ||
      formData.card.cardbank === "" ||
      formData.card.cardbranch === undefined ||
      formData.card.cardbranch === "" ||
      formData.card.cardname === undefined ||
      formData.card.cardname === ""
    ) {
      setSnackbarMessage("Please fill the card details before adding.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    dispatch(addCard(formData.card));

    // Clear form data after adding
    setFormData({ card: {} });
  };

  const handleDeletePayment = (index) => {
    // Remove card by index from Redux state
    setSelectedBank(null);
    dispatch(removeCard(index));
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const totalAmount = cardList.reduce((total, card) => {
    const amount = parseFloat(card.cardamount) || 0;
    return total + amount;
  }, 0);
  // Handlers end

  // API calls start
  // Fetch banks on component mount

  const fetchBanks = async () => {
    try {
      const response = await externalgetApi(COMMON_API_04, "GET");
      console.log("card bankss", response);
      setBanks(response);
    } catch (error) {
      console.error("Error fetching banks:", error);
      setError(error);
    }
  };

  // Fetch branches based on selected bank

  const fetchBranches = async () => {
    if (selectedBank) {
      try {
        const params = { BANKCODE: selectedBank };
        const response = await externalgetApi(COMMON_API_05, "GET", params);
        setBranches(response); // Assuming response is the array of branches
      } catch (error) {
        console.error("Error fetching branches:", error);
        setError(error);
      }
    }
  };

  // API calls end

  return (
    <Box sx={styles.cs_cash}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography
            sx={{ ...theme.typography.h2, color: theme.palette.text.primary }}
          >
            Bank Payment Details
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            label="Name"
            name="card.cardname"
            variant="outlined"
            fullWidth
            size="small"
            value={formData?.card?.cardname || ""}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            label="Account / Card No."
            name="card.cardaccountNumber" // Nested in the "card" object
            variant="outlined"
            fullWidth
            size="small"
            value={formData?.card?.cardaccountNumber || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            label="Amount"
            name="card.cardamount"
            variant="outlined"
            fullWidth
            size="small"
            value={formData?.card?.cardamount || ""}
            onChange={(e) => {
              let value = e.target.value;
              value = value.replace(",", ".");
              const regex = /^[0-9]*\.?[0-9]{0,2}$/;
              if (!regex.test(value)) return;
              e.target.value = value;
              handleChange(e);
            }}
            inputProps={{
              inputMode: "decimal",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            select
            label="Bank"
            name="card.cardbank" // Nested in the "card" object
            value={formData?.card?.cardbank || ""}
            onChange={handleBankChange}
            size="small"
            fullWidth
          >
            {banks.map((bank) => (
              <MenuItem key={bank.BANKCODE} value={bank.BANKCODE}>
                {bank.BANKNAME}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            select
            label="Branch"
            name="card.cardbranch"
            value={formData?.card?.cardbranch || ""}
            onChange={handleBranchChange}
            size="small"
            fullWidth
            disabled={!selectedBank} // Disable if no bank is selected
          >
            {branches.map((branch) => (
              <MenuItem key={branch.BRANCHCODE} value={branch.BRANCHCODE}>
                {branch.BRANCHNAME}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Button
            variant="contained"
            size="medium"
            sx={styles.btn_primary}
            fullWidth
            onClick={handleAddPayment}
          >
            Add Payment
          </Button>
        </Grid>
      </Grid>

      <hr sx={{ ...styles.border_bottom }}></hr>

      <Box pt={2}>
        {/* <Box mt={2}>
          <Typography variant="h6">
            Total Amount: {formatPrice(totalAmount)}
          </Typography>
        </Box> */}
        <Stack spacing={2}>
          {cardList.map((payment, index) => (
            <Card
              key={index}
              sx={{
                borderRadius: 2,
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                padding: "12px",
                backgroundColor: theme.palette.background.default,
                alignItems: "center",
                pt: 0,
              }}
            >
              <CardContent>
                <Grid
                  container
                  spacing={2}
                  display={"flex"}
                  alignItems={"center"}
                >
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Typography variant="caption">Name</Typography>
                    <Typography variant="sub_title" fontWeight={600}>
                      {payment.cardname}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Typography variant="caption">Bank</Typography>
                    <Typography variant="sub_title" fontWeight={600}>
                      {payment.cardbank}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    textAlign={"right"}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Typography variant="caption">Amount</Typography>
                    <Typography variant="sub_title" fontWeight={600}>
                      {formatPrice(payment.cardamount)}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    display={"flex"}
                    justifyContent={"flex-end"} // Align button to the right
                    alignItems={"center"}
                  >
                    <IconButton
                      onClick={() => handleDeletePayment(index)}
                      sx={{
                        ...styles.cs_cash_delete_icon,
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </Box>
  );
};
export default CashierCard;
